/* Clear-cart control for the Rebuy Smart Cart.
   A discreet "Clear cart" text link in the cart header with a two-tap confirm
   (so nobody empties their cart by accident). Empties via /cart/clear.js, then
   re-renders the Smart Cart in place via Rebuy.SmartCart.setCart() (no full page
   reload). Falls back to a soft reload only if Rebuy isn't available. */
(function () {
  'use strict';

  function emptyCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var SC = window.Rebuy && window.Rebuy.SmartCart;
        var rendered = false;
        try {
          if (SC && typeof SC.setCart === 'function') { SC.setCart(cart); rendered = true; }
          if (SC && typeof SC.updateCartCount === 'function') SC.updateCartCount();
          if (SC && typeof SC.updateCartSubtotal === 'function') SC.updateCartSubtotal();
        } catch (e) { rendered = false; }
        ['rebuy:cart:updated', 'cart:updated', 'cart:refresh'].forEach(function (ev) {
          try { document.dispatchEvent(new CustomEvent(ev)); } catch (e) {}
        });
        // If we couldn't drive Rebuy's re-render, fall back to a soft reload so the
        // emptied cart is never shown stale.
        if (!rendered) setTimeout(function () { window.location.reload(); }, 150);
      });
  }

  function makeLink() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kv-clear-cart';
    btn.textContent = 'Clear cart';
    var armed = false, t = null;
    function reset() { armed = false; btn.classList.remove('is-armed'); btn.textContent = 'Clear cart'; btn.disabled = false; }
    btn.addEventListener('click', function () {
      if (!armed) { armed = true; btn.classList.add('is-armed'); btn.textContent = 'Tap again to clear'; clearTimeout(t); t = setTimeout(reset, 3000); return; }
      clearTimeout(t); btn.textContent = 'Clearing…'; btn.disabled = true;
      emptyCart().then(reset).catch(reset);
    });
    return btn;
  }

  function inject() {
    if (document.querySelector('.kv-clear-cart')) return;
    var header = document.querySelector('[data-rebuy-cart-anchor="header"]') ||
      document.querySelector('.rebuy-cart__header') ||
      document.querySelector('.rebuy-cart__title');
    if (!header) return;
    header.appendChild(makeLink());
  }

  var iv = setInterval(inject, 700);
  setTimeout(function () { clearInterval(iv); }, 30000);
  ['rebuy:cart:opened', 'rebuy:cart:loaded', 'rebuy:cart:updated'].forEach(function (ev) { document.addEventListener(ev, inject); });
})();
